import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t } = useTranslation('common');

  return (
    <section id="contacto" className="relative py-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/0236242e63a9877ca1e46cceba4cf556.jpg')`
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-br from-red-900/85 via-orange-900/80 to-yellow-900/85"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            {t('contact_badge')}
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            {t('contact_title')}
          </h2>
          <p className="text-lg text-white/95 max-w-3xl mx-auto">
            {t('contact_subtitle')}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            {/* Address */}
            <div className="bg-white/95 backdrop-blur-sm p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-red-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{t('contact_address')}</h3>
                  <p className="text-gray-700 font-medium">Tienda La Bonita Market</p>
                  <p className="text-gray-600">4051 Carson Ave</p>
                  <p className="text-gray-600">Indianápolis, IN 46227</p>
                </div>
              </div>
            </div>

            {/* Hours */}
            <div className="bg-white/95 backdrop-blur-sm p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{t('contact_hours')}</h3>
                  <p className="text-gray-700 font-medium">Lunes a Domingo: 8:00 AM - 10:30 PM</p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="bg-white/95 backdrop-blur-sm p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{t('contact_phone')}</h3>
                  <a href="tel:3172790334" className="text-gray-700 font-medium hover:text-green-600 transition-colors cursor-pointer">
                    (317) 279-0334
                  </a>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="bg-white/95 backdrop-blur-sm p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{t('contact_email')}</h3>
                  <a href="mailto:labonitamarkett@gmail.com" className="text-gray-700 font-medium hover:text-blue-600 transition-colors cursor-pointer">
                    labonitamarkett@gmail.com
                  </a>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="bg-white/95 backdrop-blur-sm p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-share-line text-2xl text-purple-600"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">Síguenos en Redes Sociales</h3>
                  <div className="flex gap-4">
                    <a
                      href="https://www.instagram.com/labonitamarkett/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 rounded-xl flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                      aria-label="Instagram"
                    >
                      <i className="ri-instagram-line text-2xl text-white"></i>
                    </a>
                    <a
                      href="https://www.tiktok.com/@labonitamarket?is_from_webapp=1&sender_device=pc"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 bg-black rounded-xl flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                      aria-label="TikTok"
                    >
                      <i className="ri-tiktok-line text-2xl text-white"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* WhatsApp Button */}
            <div className="bg-white/95 backdrop-blur-sm p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all">
              <a
                href="https://wa.me/13172790334"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-4 bg-green-500 hover:bg-green-600 text-white px-8 py-6 rounded-2xl text-xl font-bold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-4xl"></i>
                <span>Contáctanos por WhatsApp</span>
              </a>
            </div>
          </div>

          {/* Google Map */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl overflow-hidden h-full">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3068.8234567890123!2d-86.14567890000001!3d39.7234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886b50a1b2c3d4e5%3A0x1234567890abcdef!2s4051%20Carson%20Ave%2C%20Indianapolis%2C%20IN%2046227!5e0!3m2!1sen!2sus!4v1234567890123"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '600px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación de Tienda La Bonita Market"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
